import React from 'react';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { ALMOST_WHITE_COLOR, BLACK_COLOR, LIGHT_GREY_COLOR } from '../../const/color-const';
import withStyles from '@material-ui/core/styles/withStyles';
import { darken } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: 320,
    textAlign: 'center',
    margin: 'auto',
    border: `1px solid ${LIGHT_GREY_COLOR}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    color: theme.palette.type === 'light' ? BLACK_COLOR : ALMOST_WHITE_COLOR,
    backgroundColor: theme.palette.type === 'light' ? 'white' : darken(BLACK_COLOR, 0.5),
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    color: theme.palette.type === 'light' ? BLACK_COLOR : ALMOST_WHITE_COLOR,
  },
  label: {
    fontSize: theme.fontSize,
    marginRight: theme.spacing(3),
    position: 'relative',
    top: 5,
  },
});

const LinearValueProgress = ({ value, classes, label }) => {
  return (
    <div className={classes.root}>
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress variant="determinate" value={value} />
        </Box>
        <Box minWidth={32}>
          <b>{`${Math.round(value)}%`}</b>
        </Box>
      </Box>
      <div className={classes.labelWrapper}>
        <span className={classes.label}>{label}</span>
        <div className="dot-flashing" />
      </div>
    </div>
  );
};

export default withStyles(styles)(LinearValueProgress);